export default class CustomerService {
    createCustomerContacts = (contacts, customer) => {
        return axios.post(`/customers/${customer}/customer-contacts`, { contacts });
    };

    getCustomerContacts = (customer) => {
        return axios.get(`/customers/${customer}/customer-contacts`);
    };
}
